import { LibrasButtonStyled } from "./style";
import SignLanguageIcon from "@mui/icons-material/SignLanguage";

interface LibrasButtonProps {
  onClick: () => void;
  variant?: "desktop" | "mobile";
}

export const LibrasButton = ({
  onClick,
  variant = "desktop",
}: LibrasButtonProps) => {
  return (
    <LibrasButtonStyled
      variant={variant}
      onClick={onClick}
      aria-label="Ativar intérprete de Libras"
      title="Libras"
    >
      <SignLanguageIcon />
    </LibrasButtonStyled>
  );
};
